import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  PageHeader,
  Input,
  Button,
  Skeleton,
} from "@/components/ui";
import {
  ContainerHeader,
  FormFrequencies,
  FrequencyDataTable,
} from "@/components/common";
import { useFetchFrequenciesQuery } from "@/hooks";

export function Frequency() {
  const { t } = useTranslation();
  const [search, setSearch] = useState<string>("");

  const {
    data: allFrequencyData,
    isLoading,
    refetch,
  } = useFetchFrequenciesQuery({ search });

  useEffect(() => {
    setTimeout(() => {
      refetch();
    }, 1500);
  }, [search, refetch]);
  return (
    <section className="space-y-7">
      <div className="space-y-5">
        <PageHeader
          eyebrow="Clínica"
          title={t("LABEL.frequency")}
          lede="Com que periodicidade — diária, semanal, mensal ou anual — a clínica repete um atendimento."
          actions={
            <FormFrequencies>
              <Button variant="petrol" size="lg" className="px-5">
                Criar
              </Button>
            </FormFrequencies>
          }
        />
        <ContainerHeader>
          <Input
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            type="search"
            aria-label="Pesquisar frequências"
            placeholder="Pesquisar"
            showError={false}
          />
        </ContainerHeader>
      </div>

      <div className="space-y-2">
        {!allFrequencyData || isLoading ? (
          <Skeleton className="w-full h-[500px]" />
        ) : (
          <FrequencyDataTable data={allFrequencyData} />
        )}
      </div>
    </section>
  );
}
